export default __webpack_public_path__ + "static/media/map-pin.79ffc283.png";